module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('claim-info', {
    attrs: {
      "claim": _vm.claim,
      "show-back": false,
      "title": "Update Claim Status"
    },
    on: {
      "save": _vm.saveClaimData
    }
  }), _vm._v(" "), _c('initial-reserves-costs', {
    attrs: {
      "claim": _vm.claim,
      "show-back-btn": false,
      "title": "Reserves & Costs"
    },
    on: {
      "save": _vm.saveReserveChanges
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-64d09fe4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/claims-dashboard/components/ReservesForClaim.vue
// module id = 1719
// module chunks = 0